import {IInvoice} from "../utils/interfaces/IInvoice";

export const csvHeaders = [
    {label: "Year", key: "year"},
    {label: "Month", key: "month"},
    {label: "Restaurateur Name", key: "restaurateur.name"},
    {label: "Restaurant Name", key: "restaurant.name"},
    {label: "Booking ID", key: "bookings.details.id"},
    {label: "Nett Price", key: "bookings.details.nett_price"},
    {label: "Gross Price", key: "bookings.details.gross_price"},
    {label: "Seat Price", key: "bookings.details.seat_price"},
    {label: "Seats", key: "bookings.details.seats"},
    // {label: "Year", key: "year"},
    // {label: "Month", key: "month"},
    {label: "Transaction Order ID", key: "transaction.order_id"},
    {label: "Transaction Amount", key: "transaction.amount"},
    {label: "Transaction Mycia Commission", key: "transaction.mycia_commission_amount"},
    {label: "Transaction Stripe Commission", key: "transaction.stripe_commission_amount"},
    {label: "Transaction Total Commission", key: "transaction.total_commission_amount"},
    {label: "Transaction Type", key: "transaction.type"},
    {label: "Transaction Date", key: "transaction.date"},
    {label: "Transaction Rebounded By", key: "transaction.rebound_id"},
    {label: "Rebound Id", key: "rebound.id"},
    {label: "Rebound Date", key: "rebound.date"},
    {label: "Rebound Total Amount to Invoice", key: "rebound.rebound_total_amount_to_invoice"},
];

export const invoice_csv_data = (invoice: IInvoice) => {
    const restaurateur = invoice.restaurateur;
    const transformedData: Array<Record<string, any>> = [];

    const formatNumberWithComma = (value: number | undefined) => {
        return value ? value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
    };


    restaurateur.restaurants.forEach((restaurant) => {
        restaurant.bookings.details.forEach((booking) => {
            const transformedItem = {
                "restaurateur.name": restaurateur.name,
                "restaurant.name": restaurant.name,
                "bookings.details.id": booking.id,
                "bookings.details.nett_price": formatNumberWithComma(booking.nett_price),
                "bookings.details.gross_price": formatNumberWithComma(booking.gross_price),
                "bookings.details.seat_price": formatNumberWithComma(booking.seat_price),
                "bookings.details.seats": booking.seats,
            };

            transformedData.push(transformedItem);
        });
        restaurant.transactions.details.forEach((transaction) => {
            const transformedItem = {
                "restaurateur.name": restaurateur.name,
                "restaurant.name": restaurant.name,
                "transaction.order_id": transaction.order_id,
                "transaction.net_amount": transaction.net_amount,
                "transaction.mycia_commission_amount": formatNumberWithComma(transaction.mycia_commission_amount),
                "transaction.stripe_commission_amount": formatNumberWithComma(transaction.stripe_commission_amount),
                "transaction.total_commission_amount": formatNumberWithComma(transaction.commission_amount),
                "transaction.type": transaction.type,
                "transaction.date": transaction.date,
                "transaction.rebound_id": transaction.rebound_id,
            };

            transformedData.push(transformedItem);
        });
        restaurant.rebounds.details.forEach((rebound) => {
            const transformedItem = {
                "restaurateur.name": restaurateur.name,
                "restaurant.name": restaurant.name,
                "rebound.id": rebound.id,
                "rebound.date": rebound.date,
                "rebound.rebound_total_amount_to_invoice": formatNumberWithComma(rebound.rebound_total_amount_to_invoice),
            };

            transformedData.push(transformedItem);
        });
    });

    return transformedData;
};


